import React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import MMPLShipCard from "./MMPLShipCard";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipPOByClientId,
  getMMPLShipSearchByClientId,
  getClassFlagData
  //getShipsByClientId,
} from "../Actions/MMPLDashboardAPI";
import ShipPOs from "./ShipPOs";
import Moment from "moment";
import CountUp from "react-countup";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { getShipnameList } from "../Actions/HelpersAPI";
import { GetKPIData } from "../Actions/CommonAPI";
import { ExportExcelShip } from "../Actions/ShipViewAPI";
import axios from "axios";
import API from "../helpers/api";
import PO from "../Asset/PO.svg";
import MyPendingTask from "../Asset/MyPendingTask.svg";
import Awaiting from "../Asset/Awaiting.svg";
import ShipPendingTask from "../Asset/ShipPendingTask.svg";
import IHMPending from "../Asset/IHMPending.svg";
import IHMUpdated from "../Asset/IHMUpdated.svg";
import shortClosed from "../Asset/shortClosed.svg";
import Ship from "../Asset/Ship.svg";
import clear from "../Asset/clear.svg";
import * as $ from 'jquery';


class MMPLDashboardClient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialSearch: 1,
      filterTitle: "All Ships",
      showPendingTask: false,
      searchShip: {
        ShipName: "",
        PageSize: 25,
      },
      PageNo: 1,
      PgSize: 25,
      shipId: 0,
      shipName: "",
      poValidationShipName: "",
      isShortClosed: false,
      isIhmPart1: false,
      isAwaitingMdAndSdoc: false,
      isPoValidation: false,
      isShipsPendingTask: false,
      isIhmUpdate2: false,
      isPurchaseOrders: true,
      TotalShip: false,
      shipSuccess: false,
      
      flag: "",
      class: "",

      clientId: this.props.match.params.id,
      ShipList: [],
      ShipFlagState: [],
      ShipClassState: []
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.renderMovieTitle = this.renderMovieTitle.bind(this);
    this.renderLookupTitle = this.renderLookupTitle.bind(this);
    this.SearchShipPOs = this.SearchShipPOs.bind(this);
    this.getShipDetails = this.getShipDetails.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem('shipName') != undefined) {
      this.state.poValidationShipName = JSON.parse(localStorage.getItem('shipName'))
      this.setState({})
    }
    const { dispatch, SearchResult } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Dashboard" });

    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.MMPLShipCount}?mmplMail=${user.email}&clientId=${this.state.clientId}`;
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipCountByClientIdSuccess",
          data: response.data,
        });
        //dispatch(getShipsByClientId(this.state.clientId));
        dispatch(getShipPOByClientId(this.state));
        dispatch(GetKPIData());
        dispatch(getClassFlagData("flag"));
        dispatch(getClassFlagData("class"));
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipCountByClientIdFailure",
          error: "ERROR",
        });
      });
    if (SearchResult) {
      dispatch(getShipPOByClientId(SearchResult, SearchResult.PageNo));
    } else {
      dispatch({
        type: "GetShipPOsByClientIdSuccess",
        data: [],
      });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, SearchResult, ShipPOByClientId, ShipFlagData, ShipClassData } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }
    if (ShipPOByClientId) {
      prevState.ShipList = ShipPOByClientId;
    }

    if (ShipFlagData) {
      prevState.ShipFlagState = ShipFlagData;
    }
    if(ShipClassData) {
      prevState.ShipClassState = ShipClassData;
    }
    if (SearchResult && SearchResult !== "" && !prevState.shipSuccess) {
      prevState.poValidationShipName = SearchResult.poValidationShipName;
      prevState.shipName = SearchResult.shipName;
      prevState.isPurchaseOrders = SearchResult.isPurchaseOrders;
      prevState.isShipsPendingTask = SearchResult.isShipsPendingTask;
      prevState.isIhmUpdate2 = SearchResult.isIhmUpdate2;
      prevState.isPoValidation = SearchResult.isPoValidation;
      prevState.isAwaitingMdAndSdoc = SearchResult.isAwaitingMdAndSdoc;
      prevState.isIhmPart1 = SearchResult.isIhmPart1;
      prevState.isShortClosed = SearchResult.isShortClosed;
      prevState.TotalShip = SearchResult.TotalShip;
      prevState.shipSuccess = true;
    }
  }

  getShipDetails(action) {
    const { dispatch } = this.props;
    this.state.initialSearch = 1;
    this.state.class = "";
    this.state.flag = "";
    if (action === 1) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = true;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({}, () => { dispatch(getShipPOByClientId(this.state)) });
      window.scrollTo(0, document.body.scrollHeight);
    } else if (action === 2) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = true;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      this.setState({}, () => { dispatch(getShipPOByClientId(this.state)) });
      window.scrollTo(0, document.body.scrollHeight);
    } else if (action === 3) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = true;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({}, () => { dispatch(getShipPOByClientId(this.state)) });
      window.scrollTo(0, document.body.scrollHeight);
    } else if (action === 4) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = true;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "PurchaseOrders", data: false });
      this.setState({}, () => { dispatch(getShipPOByClientId(this.state)) });
      window.scrollTo(0, document.body.scrollHeight);
    } else if (action === 5) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = true;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      this.setState({}, () => { dispatch(getShipPOByClientId(this.state)) });
      window.scrollTo(0, document.body.scrollHeight);
    } else if (action === 6) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = true;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      this.setState({}, () => { dispatch(getShipPOByClientId(this.state)) });
      window.scrollTo(0, document.body.scrollHeight);
    } else if (action === 7) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = true;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({}, () => { dispatch(getShipPOByClientId(this.state)) });
      window.scrollTo(0, document.body.scrollHeight);
    } else {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = true;
      this.state.shipSuccess = false;
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({}, () => { dispatch(getMMPLShipSearchByClientId(this.state, this.state.PageNo)) });
      window.scrollTo(0, document.body.scrollHeight);
    }
    if (localStorage.getItem("shipName") != undefined) {
      this.state.poValidationShipName = JSON.parse(localStorage.getItem('shipName'));
      this.state.shipName = JSON.parse(localStorage.getItem('shipName'));
      this.setState({})
    }
    this.setState({ showClientDetails: false, filterclientDetails: false });
  }
  ClearPoSearchField() {
    localStorage.removeItem("shipName")
    this.state.initialSearch = 1;
    this.state.poValidationShipName = "";
    this.state.flag = "";
    this.state.class = "";
    this.props.dispatch(getShipPOByClientId(this.state));
    this.setState({});
  }
  SearchShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLShipSearchByClientId(this.state, PgNo));
  }
  ClearShipSearchField() {
    localStorage.removeItem("shipName")
    this.state.initialSearch = 1;
    this.state.shipName = "";
    this.state.class = "";
    this.state.flag = "";
    this.props.dispatch(getMMPLShipSearchByClientId(this.state, this.state.PageNo));
    this.setState({});
  }
  handleShipInputChange(e) {
    this.state.shipName = e.target.value;
    this.setState({});
  }
  SearchShipPOs(action) {
    localStorage.removeItem("shipName")
    this.state.initialSearch = 0;
    const { dispatch } = this.props;
    dispatch(getShipPOByClientId(this.state));
  }
  renderMovieTitle(state, val) {
    return state.shipName.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  renderLookupTitle(state, val) {
    return state.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  handleInputChanges(e, field) {
    this.state[field] = e.target.value;
    this.setState({});
  }
  handleSelectChange(value, field) {
    this.state[field] = value;
    this.setState({});
  }

  downloadAwaitingExcel = () => {
    const { dispatch } = this.props;
    dispatch(ExportExcelShip());
    this.setState({});
  };

  render() {
    const {
      equipmentInfo,
      MMPLSidePanCollectDocs,
      shipMMPLCountByClientId,
      MMPLShipList,
      ShipPOByClientId,
      ShipClassData,
      ShipFlagData
    } = this.props;

    const {
      isShortClosed,
      isIhmPart1,
      isAwaitingMdAndSdoc,
      isPoValidation,
      isPurchaseOrders,
      TotalShip,
      PurchaseOrders,
      isShipsPendingTask,
      isIhmUpdate2,
    } = this.state;

    return (
      <div className="full-height pt-3 pb-1 my-4" style={{ backgroundColor: "#F1F5F9", borderRadius: 14 }}>
        <div className="mx-0 pt-2 px-4 row">
          {/* style={{ minWidth: "12.5%" }} */}
          <div className="col-lg-1 col-md-3 col-sm-6 p-1 pr-2 mb-4 " style={{ minWidth: "12.5%" }}>
            <div
              className={`${isPurchaseOrders ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              // style={{ height: "100%" }}
              onClick={() => this.getShipDetails(4)}
            >
              <img src={PO} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `} style={{
                  marginTop: 10, color: "#F77F00"
                }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCountByClientId ? shipMMPLCountByClientId.pOs : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                Purchase Orders
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2 mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isPoValidation ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              // style={{ height: "100%" }}
              onClick={() => this.getShipDetails(1)}
            >
              <img src={MyPendingTask} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#D62828" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCountByClientId ? shipMMPLCountByClientId.poValidation : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                My Pending Tasks - PO Validation
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1 col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isAwaitingMdAndSdoc ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(2)}
            >
              <img src={Awaiting} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#F77F00" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCountByClientId ? shipMMPLCountByClientId.collectMdocSdoc : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                Awaiting MD & SDoC
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isShipsPendingTask ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(6)}
            >
              <img src={ShipPendingTask} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#D62828" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={
                    shipMMPLCountByClientId
                      ? shipMMPLCountByClientId.shipsPendingTask
                        ? shipMMPLCountByClientId.shipsPendingTask
                        : 0
                      : 0
                  }
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                Ships Pending Task
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isIhmPart1 ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(3)}
            >
              <img src={IHMPending} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#F77F00" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCountByClientId ? shipMMPLCountByClientId.ihmPart1 : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                IHM Part 1 - Pending to be Updated
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isIhmUpdate2 ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(7)}
            >
              <img src={IHMUpdated} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#C5D86D" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCountByClientId ? shipMMPLCountByClientId.ihmUpdate2 : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                IHM Part 1 - Updated
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isShortClosed ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(5)}
            >
              <img src={shortClosed} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#86CD82" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCountByClientId ? shipMMPLCountByClientId.shortClosed : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                Short Closed - PO's
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${TotalShip ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails("noAction")}
            >
              <img src={Ship} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#685044" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCountByClientId ? shipMMPLCountByClientId.totalShips : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                Total Ships
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
        </div>

        {/* ships */}

        {this.state.isPurchaseOrders ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.ShipList}
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "poValidationShipName"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "flag"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "class"
                        )
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr" type="submit" onClick={() => this.SearchShipPOs(1)}> Search </button>
                    <button className="btn txtside-btn txtht-btn clearbtn w-50 clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn clearbtn w-100 clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>

              </div>
            </div>

            {ShipPOByClientId && ShipPOByClientId.length ? (
              <>
                <ShipPOs
                  arraylist={ShipPOByClientId}
                  setUpdatedState={(value) => this.SearchShipPOs(value)}
                />
              </>
            ) : this.state.initialSearch == 0 ?
              (<>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size" >
                      No Ships
                    </h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>) : null}


          </>
        ) : null}

        {this.state.isPoValidation ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.ShipList}
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "poValidationShipName"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3">
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "flag"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers  col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3">
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "class"
                        )
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr" type="submit" onClick={() => this.SearchShipPOs(1)}> Search </button>
                    <button className="btn txtside-btn txtht-btn w-50 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>

              </div>
            </div>

            {ShipPOByClientId && ShipPOByClientId.length ? (
              <div id="textbody">
                <ShipPOs
                  arraylist={ShipPOByClientId}
                  setUpdatedState={(value) => this.SearchShipPOs(value)}
                />
              </div>
            ) :
              this.state.initialSearch == 0 ?
                (<>
                  <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                    <div className="col-xl-12">
                      <h6 className="bold-count no-item-card f-size" >
                        No Ships
                      </h6>
                    </div>
                  </div>
                  <div className="pb-1"></div>
                </>) : null}

          </>
        ) : null}

        {this.state.isAwaitingMdAndSdoc ? (
          <>

            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-1 col-lg-0 col-md-0 col-sm-0 col-0 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.ShipList}
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "poValidationShipName"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "flag"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "class"
                        )
                      }
                    />
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr export-align" type="submit" onClick={() => this.downloadAwaitingExcel()}> Export to Excel </button>
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr h-100" type="submit" onClick={() => this.SearchShipPOs(1)}> Search </button>
                    <button className="btn txtside-btn txtht-btn w-50 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>

              </div>
            </div>

            {ShipPOByClientId && ShipPOByClientId.length ? (
              <ShipPOs
                arraylist={ShipPOByClientId}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ?
              (<>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size" >
                      No Ships
                    </h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>) : null}

          </>
        ) : null}

        {this.state.isIhmPart1 ? (
          <>

            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.ShipList}
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "poValidationShipName"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "flag"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "class"
                        )
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr" type="submit" onClick={() => this.SearchShipPOs(1)}> Search </button>
                    <button className="btn txtside-btn txtht-btn w-50 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>

              </div>
            </div>
            {ShipPOByClientId && ShipPOByClientId.length ? (
              <ShipPOs
                arraylist={ShipPOByClientId}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ?
              (<>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size" >
                      No Ships
                    </h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>) : null}

          </>
        ) : null}

        {this.state.isIhmUpdate2 ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.ShipList}
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "poValidationShipName"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "flag"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "class"
                        )
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr" type="submit" onClick={() => this.SearchShipPOs(1)}> Search </button>
                    <button className="btn txtside-btn txtht-btn w-50 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>

              </div>
            </div>
            {ShipPOByClientId && ShipPOByClientId.length ? (
              <ShipPOs
                arraylist={ShipPOByClientId}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ?
              (<>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size" >
                      No Ships
                    </h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>) : null}

          </>
        ) : null}

        {this.state.isShortClosed ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.ShipList}
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "poValidationShipName"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "flag"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "class"
                        )
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr" type="submit" onClick={() => this.SearchShipPOs(1)}> Search </button>
                    <button className="btn txtside-btn txtht-btn w-50 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>

              </div>
            </div>
            {ShipPOByClientId && ShipPOByClientId.length ? (
              <ShipPOs
                arraylist={ShipPOByClientId}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ?
              (<>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size" >
                      No Ships
                    </h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>) : null}

          </>
        ) : null}

        {this.state.isShipsPendingTask ? (
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      items={this.state.ShipList}
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "poValidationShipName"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "flag"
                        )
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 " >
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(
                          value,
                          "class"
                        )
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr" type="submit" onClick={() => this.SearchShipPOs(1)}> Search </button>
                    <button className="btn txtside-btn txtht-btn w-50 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>

              </div>
            </div>
            {ShipPOByClientId && ShipPOByClientId.length ? (
              <ShipPOs
                arraylist={ShipPOByClientId}
                setUpdatedState={(value) => this.SearchShipPOs(value)}
              />
            ) : this.state.initialSearch == 0 ?
              (<>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size" >
                      No Ships
                    </h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>) : null}

          </>
        ) : null}

        {this.state.TotalShip ? (
          <>
            <div className="row my-3 mx-2 pb-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        All Ships
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      <div className="col-lg-3 autocomplete-wrappers">
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        {/* <input
                          className="form-control"
                          type="text"
                          name="shipName"
                          placeholder="Ship Name"
                          onChange={(e) => this.handleShipInputChange(e)}
                          value={this.state.shipName}
                        ></input> */}
                          <Autocomplete
                            value={this.state.shipName}
                            items={this.state.ShipList}
                            getItemValue={(item) => item.shipName}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control"
                                  id="exampleFormControlInput1"
                                  placeholder="Ship Name"
                                  {...props}
                                  style={{ border: "1px solid #cfd4da" }}
                                />
                              );
                            }}
                            shouldItemRender={this.renderMovieTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdowns">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}
                              >
                                {item.shipName}
                              </div>
                            )}
                            onChange={(e, field) =>
                              this.handleInputChanges(e, "shipName")
                            }
                            onSelect={(value) =>
                              this.handleSelectChange(
                                value,
                                "shipName"
                              )
                            }
                          />                        
                      </div>
                      <div className="col-lg-3 autocomplete-wrappers">
                         <label className="form-label">Flag</label>
                         <br></br>
                          {/* <input type="text" className="form-control" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                          <Autocomplete
                            value={this.state.flag}
                            items={this.state.ShipFlagState}
                            getItemValue={(item) => item}
                            renderInput={(props) => {
                              return (
                                <input
                                  className="form-control"
                                  id="exampleFormControlInput1"
                                  placeholder="Flag"
                                  {...props}
                                  style={{ border: "1px solid #cfd4da" }}
                                />
                              );
                            }}
                            shouldItemRender={this.renderLookupTitle.bind(this)}
                            renderMenu={(item) => (
                              <div className="dropdowns">{item}</div>
                            )}
                            renderItem={(item, isHighlighted) => (
                              <div
                                className={`items ${isHighlighted ? "selected-items" : ""
                                  }`}
                              >
                                {item}
                              </div>
                            )}
                            onChange={(e, field) =>
                              this.handleInputChanges(e, "flag")
                            }
                            onSelect={(value) =>
                              this.handleSelectChange(
                                value,
                                "flag"
                              )
                            }
                          />
                      </div>
                      <div className="col-lg-3 autocomplete-wrappers" >
                         <label className="form-label">Class</label>
                         <br></br>
                         {/* <input type="text" className="form-control" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                         <Autocomplete
                          value={this.state.class}
                          items={this.state.ShipClassState}
                          getItemValue={(item) => item}
                          renderInput={(props) => {
                            return (
                              <input
                                className="form-control"
                                id="exampleFormControlInput1"
                                placeholder="Class"
                                {...props}
                                style={{ border: "1px solid #cfd4da" }}
                              />
                            );
                          }}
                          shouldItemRender={this.renderLookupTitle.bind(this)}
                          renderMenu={(item) => (
                            <div className="dropdowns">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${isHighlighted ? "selected-items" : ""
                                }`}
                            >
                              {item}
                            </div>
                          )}
                          onChange={(e, field) =>
                            this.handleInputChanges(e, "class")
                          }
                          onSelect={(value) =>
                            this.handleSelectChange(
                              value,
                              "class"
                            )
                          }
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearShipSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {MMPLShipList ? (
              <MMPLShipCard
                arraylist={MMPLShipList.data}
                pageSize={MMPLShipList.pagination.pageSize}
                totalRecords={
                  MMPLShipList.pagination.totalcount
                    ? MMPLShipList.pagination.totalcount
                    : 0
                }
                setUpdatedState={(value) => this.SearchShips(value)}
              />
            ) : this.state.initialSearch == 0 ?
              (<>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size" >
                      No Ships
                    </h6>
                  </div>
                </div> </>) : null}
          </>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    //unused
    ShortClosedSearchResults: state.MMPLDashboardReducer.MMPLShortClosedShipSearchResult,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    mDocSearchResults: state.MMPLDashboardReducer.MMPLMdocShipSearchResult,
    poSearchResult: state.MMPLDashboardReducer.MMPLPOShipSearchResult,
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    shipMMPLInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    shipMMPLSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || [],
    shipMMPLDetail: state.MMPLDashboardReducer.shipMMPLDetail || {},
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,

    //used
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
    MMPLShipList: state.MMPLDashboardReducer.MMPLShipListByClientId,
    ShipPOByClientId: state.MMPLDashboardReducer.ShipPOsByClientId,
    SearchResult: state.MMPLDashboardReducer.SearchSuccessByClientId,
    shipMMPLCountByClientId: state.MMPLDashboardReducer.ShipMMPLCountByClientId,
    ShipClassData: state.MMPLDashboardReducer.ShipClassData,    
    ShipFlagData: state.MMPLDashboardReducer.ShipFlagData,    
    
    //ShipList: state.MMPLDashboardReducer.ShipListByClientId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MMPLDashboardClient));
